var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-hero"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Your source for rare and authentic photography.")]),_c('div',{staticClass:"mx-auto"},[_c('p',{staticClass:"lead mb-4"},[_vm._v(" Find your next inspiration. ")]),_c('div',[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }